import { render, staticRenderFns } from "./staff-edit.vue?vue&type=template&id=2d465c91&scoped=true&"
import script from "./staff-edit.vue?vue&type=script&lang=ts&"
export * from "./staff-edit.vue?vue&type=script&lang=ts&"
import style0 from "./staff-edit.vue?vue&type=style&index=0&id=2d465c91&prod&lang=scss&scoped=true&"
import style1 from "./staff-edit.vue?vue&type=style&index=1&id=2d465c91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d465c91",
  null
  
)

export default component.exports